import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-[calc(100%_-_3rem)] w-full overflow-hidden" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "flex justify-between items-center box-border pt-4 border-t-2 border-t-white w-full h-12" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined text-3xl" }, "play_arrow", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined text-3xl" }, "pause", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "flex items-center h-full w-full mx-4" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "close", -1)
const _hoisted_12 = { class: "mr-1 font-semibold h-full" }

import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { IonPage, onIonViewDidEnter, IonRange } from '@ionic/vue';
import { getI18N } from '@/logic/i18n';
import { IonRangeCustomEvent, RangeKnobMoveEndEventDetail } from '@ionic/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoDisplay',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const video = ref<null | HTMLVideoElement>(null);
const isVideoPaused = ref(false);
const currentVideoTime = ref(0);
const duration = ref(0);

setInterval(() => {
    isVideoPaused.value = video.value?.paused ?? false;
    currentVideoTime.value = Math.round(video.value?.currentTime ?? 0);
    duration.value = Math.round(video.value?.duration ?? 0);
}, 50);

const language = computed(() => {
    return route.params.language.toString();
});

const videoURL = ref(`${process.env.VUE_APP_DIRECTUS}assets/${route.params.videoId.toString()}`);

function goBack(): void {
    if (video.value) {
        video.value.pause();
        video.value.currentTime = 0;
    }
    router.push({ name: 'video-selection', params: { language: language.value } });
}

function playVideo(): void {
    if (video.value) {
        video.value.play();
    }
}

function pauseVideo(): void {
    if (video.value) {
        video.value.pause();
    }
}

function setCurrentTime({detail}: {detail: RangeKnobMoveEndEventDetail}): void {
    if (video.value) {
        video.value.currentTime = Number(detail.value.toString());
    }
}

function getTimeStamp(seconds: number) {
    const date = new Date(0);
    date.setSeconds(seconds);
    return date.toISOString().substr(14, 5);
}

onIonViewDidEnter(() => {
    if (video.value) {
        video.value.currentTime = 0;
        video.value.play();
    }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), { class: "page-wrapper flex flex-col justify-start items-center" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("video", {
          autoplay: "",
          class: "w-full h-full",
          height: "2500",
          ref_key: "video",
          ref: video,
          onEnded: _cache[0] || (_cache[0] = ($event: any) => (goBack()))
        }, [
          _createElementVNode("source", {
            src: videoURL.value,
            type: "video/mp4"
          }, null, 8, _hoisted_2)
        ], 544)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          (video.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (isVideoPaused.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "flex items-center cursor-pointer select-none",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (playVideo()))
                    }, _hoisted_6))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "flex items-center cursor-pointer select-none",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (pauseVideo()))
                    }, _hoisted_8))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", null, _toDisplayString(getTimeStamp(currentVideoTime.value)), 1),
          _createVNode(_unref(IonRange), {
            class: "mx-2",
            min: 0,
            max: video.value?.duration,
            modelValue: currentVideoTime.value,
            onIonKnobMoveEnd: _cache[3] || (_cache[3] = ($event: any) => (setCurrentTime($event)))
          }, null, 8, ["max", "modelValue"]),
          (duration.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(getTimeStamp(duration.value)), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: "flex justify-center items-center cursor-pointer rounded hover:bg-gray-600 bg-opacity-30 p-1 pr-2",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (goBack()))
        }, [
          _hoisted_11,
          _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(getI18N)(_unref(language), 'back')), 1)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})